var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"Swiper",class:[
    'swiper',
    'ucrs-swiper-container',
    {
      'ucrs-swiper-container--overlay': _vm.overlay,
      'ucrs-swiper-container--overlay--vertical': _vm.overlayVertical,
      'ucrs-swiper-container--equal-heights': _vm.equalHeights,
      'ucrs-swiper-container--dots-outside': _vm.dotsPosition === 'outside',
      'ucrs-swiper-container--dots-inside': _vm.dotsPosition === 'inside',
      'ucrs-swiper-container--nav-aside': _vm.navPosition === 'aside',
      'ucrs-swiper-container--nav-aside-desktop':
        _vm.navPosition === 'aside-desktop',
      'ucrs-swiper-container--nav-bottomCenter':
        _vm.navPosition === 'bottom-center',
    },
  ]},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_vm._v(" "),(_vm.navigation)?[_vm._t("button-prev",function(){return [_c('div',{staticClass:"ucrs-swiper-nav-button swiper-button-prev",class:{
          'ucrs-swiper-nav-button--no-bg': _vm.navPosition === 'white-large',
        }},[_c('SvgIcon',{staticClass:"ucrs-arrow",class:{
            ' ucrs-arrow--tiny': _vm.navPosition !== 'white-large',
          },attrs:{"name":_vm.navPosition === 'bottom-center' || _vm.navPosition === 'white-large'
              ? 'angle-left-white'
              : 'angle-left-blue'}})],1)]}),_vm._v(" "),_vm._t("button-next",function(){return [_c('div',{staticClass:"ucrs-swiper-nav-button swiper-button-next",class:{
          'ucrs-swiper-nav-button--no-bg': _vm.navPosition === 'white-large',
        }},[_c('SvgIcon',{staticClass:"ucrs-arrow",class:{
            ' ucrs-arrow--tiny': _vm.navPosition !== 'white-large',
          },attrs:{"name":_vm.navPosition === 'bottom-center' || _vm.navPosition === 'white-large'
              ? 'angle-right-white'
              : 'angle-right-blue'}})],1)]})]:_vm._e(),_vm._v(" "),(_vm.pagination)?_c('div',{staticClass:"swiper-pagination"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }